export default {"src":"/_next/static/media/Group-25835.97ec93f7.svg","height":104,"width":104};